import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mzc-pdc/ui";
import StickyHeaderDialog from "@components_v2/dialog/sticky-header-dialog";

const SelectDialogWrapper = ({
    t,
    variant,
    open,
    children,
    disableDialog,
    title,
    isSubmitButtonDisabled,
    onHandleSubmit,
    onClose,
    selectLabel,
    ...restProps
}) => {
    if (!disableDialog) {
        const DialogComponent = variant === "expandable" ? StickyHeaderDialog : Dialog;

        return (
            <DialogComponent variant={variant} open={open} onClose={onClose} {...restProps}>
                <DialogTitle>{t(`common::label::${title}`)}</DialogTitle>
                <DialogContent>{children}</DialogContent>
                <DialogActions>
                    <Button variant={`text`} color={`secondary`} onClick={onClose}>
                        {t(`common::label::Cancel`)}
                    </Button>
                    <Button
                        variant={`contained`}
                        disabled={isSubmitButtonDisabled}
                        onClick={onHandleSubmit}
                        color={`primary`}
                    >
                        {t(`common::label::${selectLabel ? selectLabel : "Select"}`)}
                    </Button>
                </DialogActions>
            </DialogComponent>
        );
    }
    return <Box sx={{ height: "100%" }}>{children}</Box>;
};

export default SelectDialogWrapper;
